import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  DELIVERY_PLAN_LIST,
  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT,
  DELIVERY_PLAN_ADD,
  DELIVERY_PLAN_DETAIL,
  DELIVERY_PLAN_UPDATE,
  DELIVERY_PLAN_UPLOAD_SET
} from '../actions';
import {
  DeliveryPlanListSuccess,
  DeliveryPlanListError,
  DeliveryPlanSearchDeliveryOrderLineLotSuccess,
  DeliveryPlanSearchDeliveryOrderLineLotError,
  DeliveryPlanAddSuccess,
  DeliveryPlanAddError,
  DeliveryPlanDetailSuccess,
  DeliveryPlanDetailError,
  DeliveryPlanUpdateSuccess,
  DeliveryPlanUpdateError,
  DeliveryPlanUploadSetSuccess,
  DeliveryPlanUploadSetError
} from '../actions';
 
export function* watchDeliveryPlanList() {
  yield takeEvery(DELIVERY_PLAN_LIST, onDeliveryPlanList);
}

export function* watchDeliveryPlanSearchDeliveryOrderLineLot() {
  yield takeEvery(DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT, onDeliveryPlanSearchDeliveryOrderLineLot);
}

export function* watchDeliveryPlanAdd() {
  yield takeEvery(DELIVERY_PLAN_ADD, onDeliveryPlanAdd);
}

export function* watchDeliveryPlanDetail() {
  yield takeEvery(DELIVERY_PLAN_DETAIL, onDeliveryPlanDetail);
}

export function* watchDeliveryPlanUpdate() {
  yield takeEvery(DELIVERY_PLAN_UPDATE, onDeliveryPlanUpdate);
}

export function* watchDeliveryPlanUpload() {
  yield takeEvery(DELIVERY_PLAN_UPLOAD_SET, onDeliveryPlanUpload);
}

const onDeliveryPlanListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onDeliveryPlanUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onDeliveryPlanSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onDeliveryPlanAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onDeliveryPlanDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onDeliveryPlanUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/delivery_plan/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_delivery_plans/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_delivery_plans/'});
      });
    });
  });
};


function* onDeliveryPlanList(data) {
  try {
    const response = yield call(onDeliveryPlanListAsync, data.payload);
    yield put(DeliveryPlanListSuccess(response.data));
  } catch (error) {
    yield put(DeliveryPlanListError(error));
  }
}

function* onDeliveryPlanSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onDeliveryPlanSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(DeliveryPlanSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(DeliveryPlanSearchDeliveryOrderLineLotError(error));
  }
}

function* onDeliveryPlanAdd(data) {
  try {
      const response = yield call(onDeliveryPlanAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(DeliveryPlanAddSuccess(response.data));
  } catch (error) {
      yield put(DeliveryPlanAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onDeliveryPlanDetail(data) {
  try {
    const response = yield call(onDeliveryPlanDetailAsync, data.payload);
    yield put(DeliveryPlanDetailSuccess(response.data));
  } catch (error) {
    yield put(DeliveryPlanDetailError(error));
  }
}

function* onDeliveryPlanUpdate(data) {
  try {
      const response = yield call(onDeliveryPlanUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(DeliveryPlanUpdateSuccess(response.data));
  } catch (error) {
      yield put(DeliveryPlanUpdateError(error));
  }
}

function* onDeliveryPlanUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onDeliveryPlanUploadAsync, file);
    if(response.message ==='success'){
      yield put(DeliveryPlanUploadSetSuccess(response));
    }
    else{
      yield put(DeliveryPlanUploadSetError(response));
    }
  } catch (error) {
    yield put(DeliveryPlanUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchDeliveryPlanList),
    fork(watchDeliveryPlanSearchDeliveryOrderLineLot),
    fork(watchDeliveryPlanAdd),
    fork(watchDeliveryPlanDetail),
    fork(watchDeliveryPlanUpdate),
    fork(watchDeliveryPlanUpload),
  ]);
} 